
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Définition du Scoring: Comprendre son Importance et son Fonctionnement",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez la définition scoring et son importance dans les décisions commerciales. Évaluez les performances grâce à ce puissant outil d'analyse.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Définition du Scoring: Comprendre son Importance et son Fonctionnement",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez la définition scoring et son importance dans les décisions commerciales. Évaluez les performances grâce à ce puissant outil d'analyse.",
        },
      ],
    };
  },
};
